export type StudentCallLog = {
    id: number
    studentProfileId: number
    customProfileId: string
    studentFullName: string
    staffFullName: string
    createdAt: string
    connectedAt?: string
    endedAt?: string
    duration?: number
    status?: string
    provider?: string
    recordingUrl?: string
    calleePhoneNumber: string
    phone: string
    isInbound: boolean
}

export type CallLogStats = Partial<{
    totalCalls: number
    totalStudents: number
    totalStaffs: number
    totalRecords: number
    totalRecordsInMinutes: number
}>

export enum CallLogStatus {
    NotStart = "not-start",
    Queued = "queued",
    Initiated = "initiated",
    Ringing = "ringing",
    InProgress = "in-progress", // same as connected
    Completed = "completed",
    Canceled = "canceled",
    NoAnswer = "no-answer",
    Busy = "busy",
    Failed = "failed"
}

export const CallLogStatusOptions = [
    {id: CallLogStatus.NotStart, name: "Not Start"},
    {id: CallLogStatus.Queued, name: "Queued"},
    {id: CallLogStatus.Initiated, name: "Initiated"},
    {id: CallLogStatus.Ringing, name: "Ringing"},
    {id: CallLogStatus.InProgress, name: "In Progress"},
    {id: CallLogStatus.Completed, name: "Completed"},
    {id: CallLogStatus.Canceled, name: "Canceled"},
    {id: CallLogStatus.NoAnswer, name: "No Answer"},
    {id: CallLogStatus.Busy, name: "Busy"},
    {id: CallLogStatus.Failed, name: "Failed"}
]

export const InboundOutboundOptions = [
    {id: "inbound", name: "Inbound"},
    {id: "outbound", name: "Outbound"}
]
